import { useState } from "react"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { GetRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"
import { ERequestType } from "../../Enum/ERequestType"
import { DeliveryRoutePlan } from "../../Objects/DeliveryEntity/DeliveryRoutePlan"

export const useDeliveryRoutePlan = () => {
  const { t } = useTranslation("general")

  const { setError } = useError()

  const [isLoadingRoutePlan, setIsLoadingRoutePlan] = useState(false)

  const handleGetRoutePlan = async (onSuccess: (plan: DeliveryRoutePlan) => void) => {
    setIsLoadingRoutePlan(true)

    try {
      const response = await GetRequest<DeliveryRoutePlan>(API_ROUTES.DELIVERY.COURIER_ROUTE_PLAN, ERequestType.Courier)

      if (response.success) {
        onSuccess(new DeliveryRoutePlan(response.data ?? {}))

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      setIsLoadingRoutePlan(false)
    }
  }

  const handleGetCourierRoutePlanForRestaurant = async (
    courierId: string,
    onSuccess: (plan: DeliveryRoutePlan) => void,
  ) => {
    setIsLoadingRoutePlan(true)

    try {
      const response = await GetRequest<DeliveryRoutePlan>(API_ROUTES.DELIVERY.RESTAURANT_COURIER_ROUTE_PLAN(courierId))

      if (response.success) {
        onSuccess(new DeliveryRoutePlan(response.data ?? {}))

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")

      setError(t("label_title_erro"), message)
    } finally {
      setIsLoadingRoutePlan(false)
    }
  }

  return {
    isLoadingRoutePlan,
    handleGetRoutePlan,
    handleGetCourierRoutePlanForRestaurant,
  }
}
